module.exports = __webpack_public_path__ + "static/img/zhiyedaode.67329e94.jpg";